/**
 * Events Frontend JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
    const eventsSlider = document.querySelector('#dpi-events-list');

    if (!eventsSlider) return;

    const swiper = new Swiper(eventsSlider, {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination-events',
            clickable: true,
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
            }
        }
    });
});